module.exports = __webpack_public_path__ + "static/media/box-nopadding.37a3489e.png";